import { Tooltip } from "./tooltip";
import { TooltipContent } from "./tooltip-content";
export * from "./tooltip";
export * from "./tooltip-content";
export var TOOLTIP_DIRECTIVES = [
    Tooltip,
    TooltipContent
];
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/popover/tooltip/index.js
// module id = 208
// module chunks = 4